<template>
  <div
    class="carousel-container"
    :style="{ width: '70%' }"
    @mouseenter="pauseAutoPlay"
    @mouseleave="resumeAutoPlay"
  >
    <div
      class="carousel-track"
      :style="trackStyle"
      @mousedown="startDrag"
      @mousemove="handleDrag"
      @mouseup="endDrag"
      @mouseleave="endDrag"
    >
      <div
        v-for="(item, index) in visibleItems"
        :key="index"
        class="carousel-item"
        :style="itemStyle"
        @click="handleItemClick(item, $event)"
      >
        <img :src="item.image || item.img" draggable="false" class="card-image" :alt="item.title" />
        <div class="text_wrap">
          <div class="card-text">{{ item.title }}</div>
          <div class="content">{{ item.content ? item.content[0] : item.overview }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      required: true
    },
    interval: {
      type: Number,
      default: 2000
    }
  },

  data () {
    return {
      virtualIndex: 6,
      displayCount: 3,
      isDragging: false,
      startX: 0,
      startY: 0,
      dragDistance: 0,
      containerWidth: 0,
      timer: null,
      isResetting: false,
      pendingIndex: null,
      mouseDownTime: 0,  // 记录鼠标按下时间
      totalDragDistance: 0  // 记录总拖动距离
    }
  },

  computed: {
    visibleItems () {
      return [...this.items, ...this.items, ...this.items]
    },

    itemStyle () {
      return {
        flex: `0 0 ${100 / this.displayCount}%`
      }
    },

    trackStyle () {
      const itemWidth = 100 / this.displayCount
      const offset = -this.virtualIndex * itemWidth
      return {
        transform: `translateX(${offset}%)`,  // 偏移量
        transition: (this.isResetting || this.isDragging) ? 'none' : 'transform 0.5s ease'  // 是否拖动影响动画
      }
    }
  },

  mounted () {
    this.updateContainerWidth()
    window.addEventListener( 'resize', this.updateContainerWidth )
    this.startAutoPlay()
  },

  beforeDestroy () {
    window.removeEventListener( 'resize', this.updateContainerWidth )
    clearInterval( this.timer )
  },

  methods: {
    handleItemClick(item, event) {
      // 如果拖动距离超过10px，阻止跳转
      if (this.totalDragDistance > 10) {
        event.preventDefault()
        event.stopPropagation()
        this.totalDragDistance = 0  // 重置
        return
      }
      
      // 只有真正点击（没有拖动或拖动很小）时才跳转
      if (item.id) {
        this.$router.push(`/coreTechnology/detail/${item.id}`)
      }
      
      this.totalDragDistance = 0  // 重置
    },

    updateContainerWidth () {
      const container = this.$el
      if (container) {
        this.containerWidth = container.offsetWidth   // 获取元素宽度
        this.calculateDisplayCount()
      }
    },

    calculateDisplayCount () {
      if (this.containerWidth < 400) {
        this.displayCount = 1
      } else if (this.containerWidth < 600) {
        this.displayCount = 2
      } else {
        this.displayCount = 3
      }
    },

    startAutoPlay () {
      clearInterval(this.timer)
      this.timer = setInterval( () => {
        this.virtualIndex++
        this.checkBoundary()
      }, this.interval )
    },

    checkBoundary() {
      this.isResetting = false
      if (this.virtualIndex === this.items.length * 2 +1) {
        this.isResetting = true;
        this.virtualIndex = this.items.length;
      }
      if (this.virtualIndex === this.items.length - 2) {
        this.isResetting = true;
        this.virtualIndex = this.items.length*2 - 1;
      }
    },


    pauseAutoPlay () {
      clearInterval( this.timer )
    },
    resumeAutoPlay () {
      if (!this.isDragging) {
        this.startAutoPlay()
      }
    },

    startDrag ( e ) {
      this.isDragging = true
      this.startX = e.clientX
      this.startY = e.clientY
      this.mouseDownTime = Date.now()
      this.totalDragDistance = 0  // 重置拖动距离
      this.pauseAutoPlay()
    },

    handleDrag ( e ) {
      if (!this.isDragging) return

      this.dragDistance = e.clientX - this.startX
      
      // 累计拖动距离（绝对值）
      const currentDistance = Math.abs(this.dragDistance)
      if (currentDistance > this.totalDragDistance) {
        this.totalDragDistance = currentDistance
      }
      
      if (Math.abs( this.dragDistance ) > 50) {
        this.handleSwipe()
        this.endDrag()
      }
    },

    handleSwipe () {
      if (this.dragDistance > 0) {
        this.virtualIndex--
      } else {
        this.virtualIndex++
      }
      this.$nextTick( () => this.checkBoundary())
    },

    endDrag () {
      this.isDragging = false
      this.startX = 0
      this.startY = 0
      this.dragDistance = 0
      this.resumeAutoPlay()
      
      // 不立即重置 totalDragDistance，让 click 事件能够判断
    }
  }
}
</script>

<style scoped lang="scss">
.carousel-container {
  margin: 0 auto;
  overflow: hidden;
  position: relative;
}

.carousel-track {
  display: flex;
  height: 100%;
  will-change: transform;  /* 添加关键样式防止布局抖动 */
  transition: transform 0.5s ease;
}

.carousel-item {
  //flex-shrink: 0;
  flex: 1;
  padding: 10px;
  box-sizing: border-box;
  cursor: pointer;
  transition: transform 0.3s ease;
  
  &:hover {
    transform: translateY(-5px);
  }
  
  .card-image {
    width: 100%;
    height: auto;
    object-fit: cover;
    border-radius: 8px;
  }
  .text_wrap {
    display: flex;
    flex-direction: column;
    max-height: none;
    padding-left: 20px;
    padding-right: 20px;
    background: #f2f2f2;
    color: rgb(85, 85, 85);
    text-overflow: ellipsis;
    .card-text {
      display: -webkit-box;
      margin-bottom: 18px;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;
      overflow: hidden;
      font-size: 16px;
      margin-top: 20px;
      transition-property: all;
      transition-duration: 0.6s;
      transition-timing-function: cubic-bezier(0.25, 0.1, 0.25, 1);
      font-weight: bold;
    }
    .content {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
      font-size: 14px;
      margin-bottom: 18px;
      line-height: 2;
    }
  }
}

@media (max-width: 600px) {
  .card-image {
    height: 150px;
  }
}

@media (max-width: 400px) {
  .card-image {
    height: 120px;
  }
}
</style>
